import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Список заявок на квоту
  listQuotaApplication (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }

    return axios.get(`${i18n.locale}/api/quotaApplication/getUserQuotaApplications?${filter}`)
  },
  // Получение данных для страницы список заявок на квоту организации
  getOoptQuotaApplicationListData (id) {
    return axios.get(`${i18n.locale}/api/quotaApplication/ooptQuotaListData/${id}`)
  },
  // Список заявок на квоту организации
  listQuotaApplicationByOopt (id, filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/quotaApplication/getOoptQuotaApplications/${id}?${filter}`)
  },
  // Получение данных для формы создания квоты
  getQuotaApplicationFormData (id) {
    return axios.get(`${i18n.locale}/api/quotaApplication/formData/${id}`)
  },
  // Обновление заявки на квоту
  updateQuotaApplication (id, data, statusId) {
    return axios.post(`${i18n.locale}/api/quotaApplication/editQuotaApplication/${id}/${statusId}`, data)
  },
  // Получение данных для отображения заявки на квоту
  showQuotaApplication (id) {
    return axios.get(`${i18n.locale}/api/quotaApplication/showQuotaApplication/${id}`)
  },
  // Создание сущности FaunaQuota
  createFaunaQuota (id) {
    return axios.get(`${i18n.locale}/api/quotaApplication/createFaunaQuota/${id}`)
  },
  // Обновление сущности FaunaQuota
  updateFaunaQuota (id, data) {
    return axios.post(`${i18n.locale}/api/quotaApplication/updateFaunaQuota/${id}`, data)
  },
  // Удаление сущности FaunaQuota
  deleteFaunaQuota (id) {
    return axios.delete(`${i18n.locale}/api/quotaApplication/deleteFaunaQuota/${id}`)
  },
  // создание заявки на квоту
  createQuotaApplication (id, statusId, data) {
    return axios.post(`${i18n.locale}/api/quotaApplication/createQuotaApplication/${id}/${statusId}`, data)
  },
  // Получение данных для отображения заявки на квоту
  quotaApplicationLastHistoryInfo (id) {
    return axios.get(`${i18n.locale}/api/quotaApplication/getLastQuotaApplicationStatusHistory/${id}`)
  },
  // Список действий
  getQuotaApplicationActions (statusId) {
    return axios.get(`${i18n.locale}/api/quotaApplication/actions/${statusId}`)
  },
  // Изменение статуса
  changeStatusQuotaApplication (id, data) {
    return axios.post(`${i18n.locale}/api/quotaApplication/changeStatus/${id}`, data)
  },
  // создание заявки "Выделение квоты на добычу диких животных"
  createAllocateQuotas (id, data) {
    return axios.post(`${i18n.locale}/api/quotaApplication/allocateQuotas/${id}`, data)
  },
  // отклонение заявки на квоту
  refuseQuotaApplication (id, data) {
    return axios.post(`${i18n.locale}/api/quotaApplication/refuse/${id}`, data)
  },
  // Получение данных для страницы квоты
  getQuotaFilterData () {
    return axios.get(`${i18n.locale}/api/quota/getQuotaFilterFormData`)
  },
  // Список квот
  listQuota (year, filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }

    return axios.get(`${i18n.locale}/api/quota/getUserQuotas/${year}?${filter}`)
  },
  // Список квот для охотхозяйств
  listOoptQuotas (id, year, filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }

    return axios.get(`${i18n.locale}/api/quota/getOoptQuotas/${id}/${year}?${filter}`)
  },
  // Получение данных для страницы QuotaApplications
  getQuotaApplicationFilterData () {
    return axios.get(`${i18n.locale}/api/quotaApplication/getSearchFormData`)
  },
  // печать в ворд по ООПТ и году
  printOoptQuota (id, yearId) {
    return axios.get(`${i18n.locale}/api/quota/printOoptQuota/${id}/${yearId}`, { responseType: 'arraybuffer' })
  },
  // печать в ворд по user и году
  printUserQuotas (yearId) {
    return axios.get(`${i18n.locale}/api/quota/printUserQuotas/${yearId}`, { responseType: 'arraybuffer' })
  },
  // получение инфы об аннулированных квотах
  getQuotaCanceledInfo (id) {
    return axios.get(`${i18n.locale}/api/quota/getQuotaCanceledInfo/${id}`)
  },
  // редактирование аннулированных квот
  editCancelQuotas (id, statusId, data) {
    return axios.post(`${i18n.locale}/api/quota/editCancelQuotas/${id}/${statusId}`, data)
  },
  // Удаление файла аннулированных квот
  deleteQuotaCanceledFile (id) {
    return axios.delete(`${i18n.locale}/api/quota/deleteQuotaCanceledFile/${id}`)
  },
  // Удаление квоты
  deleteQuota (id) {
    return axios.delete(`${i18n.locale}/api/quota/deleteQuota/${id}`)
  },
  // Получение данных для страницы аннулирование квоты
  getQuotaCanceledFormData () {
    return axios.get(`${i18n.locale}/api/quota/getQuotaCanceledFormData`)
  },
  // Создание аннулирование квоты
  createCancelQuotas (id, statusId, data) {
    return axios.post(`${i18n.locale}/api/quota/createCancelQuotas/${id}/${statusId}`, data)
  },
  // Сводный отчет квот по году
  getSummaryTableByYear (yearId) {
    return axios.get(`${i18n.locale}/api/quota/getSummaryTableByYear/${yearId}`)
  },
  // Сводный отчет квот по ООПТ и году
  getSummaryTableByOoptAndYear (ooptId, yearId) {
    return axios.get(`${i18n.locale}/api/quota/getSummaryTableByOoptAndYear/${ooptId}/${yearId}`)
  },
  // Получение данных для формы квоты
  getQuotaApplicationDocumentFormData () {
    return axios.get(`${i18n.locale}/api/quotaApplication/getQuotaApplicationDocumentFormData`)
  },
  // Удаление сущности документа квоты
  deleteDocument (id) {
    return axios.delete(`${i18n.locale}/api/quotaApplication/deleteQuotaApplicationDocument/${id}`)
  },
  // Получение данных для отображения документа заявки квоты
  showQuotaApplicationDocument (id) {
    return axios.get(`${i18n.locale}/api/quotaApplication/getQuotaApplicationDocumentInfo/${id}`)
  },
  // Создание/обновление документа заявки на квоту
  updateQuotaApplicationDocument (params, data) {
    return axios.post(`${i18n.locale}/api/quotaApplication/${params.route}/${params.id}`, data)
  }
}
